import { render } from "./ProcessPage.vue?vue&type=template&id=d01cd5ca&scoped=true"
import script from "./ProcessPage.vue?vue&type=script&lang=js"
export * from "./ProcessPage.vue?vue&type=script&lang=js"

import "./ProcessPage.vue?vue&type=style&index=0&id=d01cd5ca&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01cd5ca"]])

export default __exports__